import React from 'react';
import { ToastContainer, Zoom } from 'react-toastify';

export const toastifyConfiguration = () => {
  return (
    <ToastContainer
      transition={Zoom}
      position="bottom-right"
      autoClose={2000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable
      pauseOnHover
    />
  );
};
